import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@instructure/ui-buttons';
import t from '@instructure/quiz-i18n/format-message';
import { SecondaryNavBarButton } from '../../layout/navbar/SecondaryNavBarButton';
export var ReturnButton = /*#__PURE__*/function (_Component) {
  function ReturnButton() {
    _classCallCheck(this, ReturnButton);
    return _callSuper(this, ReturnButton, arguments);
  }
  _inherits(ReturnButton, _Component);
  return _createClass(ReturnButton, [{
    key: "render",
    value: function render() {
      if (!this.props.returnToUrl) {
        return null;
      }
      if (this.props.iceTopNavBarEnabled) {
        return /*#__PURE__*/React.createElement(SecondaryNavBarButton, {
          id: this.props.id,
          key: this.props.id,
          variant: "button",
          "data-automation": "sdk-return-button",
          href: this.props.returnToUrl,
          target: "_top"
        }, this.props.text);
      }
      return /*#__PURE__*/React.createElement(Button, {
        "data-automation": "sdk-return-button",
        href: this.props.returnToUrl,
        target: "_top"
      }, this.props.text);
    }
  }]);
}(Component);
_defineProperty(ReturnButton, "displayName", 'ReturnButton');
_defineProperty(ReturnButton, "propTypes", {
  returnToUrl: PropTypes.string,
  text: PropTypes.string,
  id: PropTypes.string,
  iceTopNavBarEnabled: PropTypes.bool
});
_defineProperty(ReturnButton, "defaultProps", {
  returnToUrl: void 0,
  text: t('Return'),
  id: 'ReturnButton',
  iceTopNavBarEnabled: false
});
export default ReturnButton;